<template>
  <div class="top">
    <div class="left-cintent">
      
      <img :src="weatherData.url" alt="☀">
        <div class="describe">{{ weatherData.weather }} </div>
        <div class="code">{{ weatherData.temperature }}℃</div>
      <!-- <img src="@/assets/images/bigScreen/icon-sy.png" @click="goHome"/> -->
      <!-- <span @click="goHome">返回首页</span> -->
    </div>
    <div class="center-content">
      <img
      src="@/assets/images/bigScreen/icon-yjt.png"
      style="transform: rotate(180deg);"
      @click="nextInfo('reduce')"/>
      <!-- <el-popover
        placement="bottom"
        :width="$remToPx(3)"
        trigger="hover"
        popper-class="top-popover"
      >
        <ul class="list-row">
          <li v-for="(item, index) in list" :key="item.id" class="list-col" @click="nextInfo(index)">
            <span>{{item.name}}</span>
            <img src="@/assets/images/bigScreen/icon-xz.png" v-if="item.name === name"/>
          </li>
        </ul>
         <div slot="reference" class="garden-name">
          {{name || '-'}}
          <img src="@/assets/images/bigScreen/icon-xl.png"/>
        </div>
      </el-popover> -->
      <div class="garden-name"> {{name}}</div>
      <!-- <div class="garden-name">{{name || '-'}}</div> -->
      <!-- <div class="garden-name">虹桥国际科技广场</div> -->
      <img
      src="@/assets/images/bigScreen/icon-yjt.png"
      @click="nextInfo('plus')"/>
    </div>
    <div class="right-content">
      <!-- <div class="weather">
        <img :src="weatherData.url" alt="☀">
        <div class="describe">{{ weatherData.weather }}</div>
        <div class="code">{{ weatherData.temperature }}℃</div>
      </div> -->
      <!-- <el-divider direction="vertical"></el-divider> -->
      <div class="time">
        <i class="el-icon-time"/>
        <p>{{time}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getWeather } from '@/utils/AmapApi'
import moment from 'moment'
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      weatherData: {
        temperature: '',
        url: '',
        weather: ''
      },
      timer: null,
      time: ''
    }
  },
  methods: {
    getWeather () {
      getWeather().then(res => {
        this.weatherData = {
          ...res
        }
      })
    },
    getTime () {
      this.time = moment().format('YYYY-MM-DD HH:mm:ss')
    },
    nextInfo (type) {
      console.log(type, '1111')
      this.$emit('change', type)
    },
    goHome () {
      this.$router.push('/home')
    }
  },
  mounted () {
    this.getWeather()
    this.getTime()
    this.timer = setInterval(this.getTime, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>
<style lang="scss">
.top-popover {
  top: 0.5rem;
  background: rgba(32, 63, 102, 0.8);
  border-color: rgba(19, 180, 230, 0.9);
  .popper__arrow {
    border-bottom-color: rgba(19, 180, 230, 0.9) !important;
    &::after {
      border-bottom-color: rgba(32, 63, 102, 0.8) !important;
    }
  }
  .list-row {
    max-height: 3rem;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    .list-col {
      height: 0.4rem;
      font-size: 0.16rem;
      color: #E9F5FF;
      border-bottom: 0.01rem solid rgba(19, 180, 230, 0.9);
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        height: 0.24rem;
        width: 0.24rem;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.top {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 0.08rem 0.2rem;
  display: flex;
  justify-content: center;
  color: #EAFEFD;
  background: url("~@/assets/images/bigScreen/bg-title.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  width: 4096px;
  box-sizing: border-box;
  .left-cintent {
    flex: 1;
    height: 0.5rem;
    display: flex;
    align-items: center;
    img {
      width: 0.18rem;
      cursor: pointer;
      margin-right: 0.1rem;
    }
    span {
      cursor: pointer;
    }
  }
  .center-content {
    flex: 1;
    height: 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 6rem;
    img {
      width: 0.4rem;
    }
    .garden-name {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      // background-image: linear-gradient(to bottom, #FFFFFF, #A8C6E1);
      // color: transparent;
      img {
        width: 0.16rem;
        margin-left: 0.2rem;
        height: 0.1rem;
      }
    }
  }
  .right-content {
    flex: 1;
    // display: flex;
    height: 0.5rem;
    // align-items: center;
    // justify-content: right;
    position: relative;
    .weather {
      width: 1.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        width: 0.3rem;
      }
      padding-right: 0.1rem;
      box-sizing: border-box;
    }
    .time {
      padding-left: 0.1rem;
      position: absolute;
      right: 20px;
      top: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      i {
        margin-right: 0.1rem;
      }
    }
  }
}
</style>